module.exports = __webpack_public_path__ + "img/neis-urazoe.271135cb.jpg";